import { render } from "./TtnsListTMS.vue?vue&type=template&id=5668e047&scoped=true&ts=true"
import script from "./TtnsListTMS.vue?vue&type=script&lang=ts"
export * from "./TtnsListTMS.vue?vue&type=script&lang=ts"

import "./TtnsListTMS.vue?vue&type=style&index=0&id=5668e047&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5668e047"]])

export default __exports__